import type { Subscription } from "../api/subscriptions";

export function getTierAvailabilityMap(
  subscriptions: Subscription[],
): Map<string, boolean> {
  const map = new Map<string, boolean>();
  for (const sub of subscriptions) {
    for (const tier of sub.tiers ?? []) {
      map.set(tier.id, tier.isAvailable ?? false);
    }
  }
  return map;
}

export function isTierAvailable(
  subscriptions: Subscription[],
  tierId: string,
): boolean {
  if (!tierId) return false;
  return getTierAvailabilityMap(subscriptions).get(tierId) ?? false;
}
